 // Baumstruktur aus E-Mails & Ordnern bauen
 export function buildTreeData (emails, folders) {
    const treeData = [];
    const folderMap = {};

    // 1️⃣ Ordner zu `folderMap` hinzufügen
    folders.forEach(folder => {
      folderMap[folder.id] = {
        key: `folder-${folder.id}`,
        id: folder.id,
        label: folder.name,
        type: 'folder',
        expanded: false
      };
    });

    // 2️⃣ E-Mails in die passenden Ordner einsortieren
    emails.forEach(email => {
      const emailNode = {
        key: `email-${email.id}`,
        id: email.id,
        label: email.title,
        type: 'email'
      };

      if (email.folder_id && folderMap[email.folder_id]) {
        folderMap[email.folder_id].children.push(emailNode);
      } else {
        treeData.push(emailNode);
      }
    });

    // 3️⃣ Ordner in die Baumstruktur einfügen
    Object.values(folderMap).forEach(folder => {
      treeData.push(folder);
    });

    console.log("Baumstruktur geladen:", treeData);
    return treeData
    
  };